
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapMutations, mapState} from 'vuex';
    import moment from 'moment';
    import PlaeneDatatable from './PlaeneDatatable.vue';
    import PlanDetailmaske from './PlanDetailmaske.vue';
    import Reiseplan from '@/types/Reiseplan';
    import {PlanFilter, PlanFilterPayload} from '@/store/patientreiseplaene';

    @Component({
        components: {
            PlanDetailmaske,
            PlaeneDatatable,
        },
        computed: {
            ...mapState('patient', ['dialogs', 'patientData', 'selected_reiseplan', 'selected_text', 'aktuelleAnzeigen']),
        },
        methods: {
            ...mapMutations('patient', [
                'setDialogReiseplan',
                'setSelectedReiseplan',
                'setReisePlanAktuelle',
            ]),
            ...mapActions('patient', ['getReiseplaene']),
        },
    })
    export default class PlaeneTabitem extends Vue {
        public setSelectedReiseplan!: (plan: Reiseplan) => void;
        public setDialogReiseplan!: (visible: boolean) => void;
        public getReiseplaene!: (payload?: PlanFilterPayload) => void;
        public setReisePlanAktuelle!: (aktuelle: any) => void;
        public aktuelleAnzeigen: any;

        public filter: PlanFilter = {
            aktuelle: '',
        };

        public mounted() {
            this.filter.aktuelle = this.aktuelleAnzeigen;
        }

        @Watch('aktuelleAnzeigen')
        public changeAktuelle() {
            this.filter.aktuelle = this.aktuelleAnzeigen;
        }

        public onClickNew(): void {
            this.setSelectedReiseplan(new Reiseplan({
                datum: moment().format('YYYY-MM-DD'),
            }));
            this.setDialogReiseplan(true);
        }

        public openPlan(plan: Reiseplan): void {
            this.setSelectedReiseplan(plan);
            this.setDialogReiseplan(true);
        }

        public onChangeFilter(): void {
            //this.getReiseplaene({ filter: this.filter });
            this.setReisePlanAktuelle(this.filter.aktuelle);
        }
    }
